import React from 'react';
import { LayoutFullscreen } from '../../layouts/layout-fullscreen';
import teaserVid from '../../assets/media/v2-Platform-Coming-soon-teaser.mp4';

const Teaser = () => {
  return (
    <>
      <LayoutFullscreen>
        <h2 className="text-white">The next generation Arcanum Platform is on its way!</h2>
        <br />
        <br />
        <video controls width="100%">
          <source src={teaserVid} type="video/mp4" />
        </video>
      </LayoutFullscreen>
    </>
  );
};

export { Teaser };
